var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1C2033",
    width: 52,
    height: 52,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9008 16.6008L41.1008 3.00078C40.3008 2.20078 39.2008 1.80078 38.1008 1.80078H14.1008C10.7008 1.80078 7.80078 4.60078 7.80078 8.10078V56.1008C7.80078 59.5008 10.6008 62.4008 14.1008 62.4008H49.8008C53.2008 62.4008 56.1008 59.6008 56.1008 56.1008V19.6008C56.1008 18.5008 55.7008 17.4008 54.9008 16.6008ZM41.2008 9.40078L48.7008 16.8008H41.2008V9.40078ZM49.9008 57.8008H14.1008C13.1008 57.8008 12.3008 57.0008 12.3008 56.0008V8.00078C12.3008 7.00078 13.1008 6.20078 14.1008 6.20078H36.7008V19.0008C36.7008 20.2008 37.7008 21.3008 39.0008 21.3008H51.7008V56.0008C51.6008 57.0008 50.8008 57.8008 49.9008 57.8008Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9008 29.1016H21.6008C20.4008 29.1016 19.3008 30.1016 19.3008 31.4016C19.3008 32.7016 20.3008 33.7016 21.6008 33.7016H38.9008C40.1008 33.7016 41.2008 32.7016 41.2008 31.4016C41.2008 30.1016 40.2008 29.1016 38.9008 29.1016Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9008 40.1016H21.6008C20.4008 40.1016 19.3008 41.1016 19.3008 42.4016C19.3008 43.7016 20.3008 44.7016 21.6008 44.7016H38.9008C40.1008 44.7016 41.2008 43.7016 41.2008 42.4016C41.2008 41.1016 40.2008 40.1016 38.9008 40.1016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.86757d2411605b186dd62024be68e155.svg";
export { ForwardRef as ReactComponent };